import { GetInfoAuth } from 'domain/usecases/auth/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetInfoAuth implements GetInfoAuth {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetInfoAuth.Model>;

  constructor(url: string, httClient: HttpClient<GetInfoAuth.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (): Promise<GetInfoAuth.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
